import React from 'react';
import Logo from '../assets/icons/RCU_Logo__white.svg';
import Navbar from 'react-bootstrap/Navbar';


export default class Header extends React.Component { 
  // constructor(props) {
  //   super(props);
	// }

	render() {
    return (
      <div id="nav">
        <Navbar expand="lg" className="bg-color-nav">
          <Navbar.Brand>
            <img
              src={Logo}
              
              id="logo"
              alt="RCU Logo"
            />
          </Navbar.Brand>
        </Navbar>
      </div>
    );
	}
}